export enum ComposeSnapshotSurface {
  DIALOG = 'DIALOG',
  PANEL = 'PANEL',
}
